import React from 'react'
import '../style/loading.css';
const LoadingGifx = () => <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'90vh'}}>

        <div class="rhombus">
                <div class="circle1"></div>
                <div class="circle2"></div>
        </div>
</div>

export default LoadingGifx



// WEBPACK FOOTER //
// ./src/components/Loading-gif2.js